<template>
    <nav>
        <ul class="pagination tabs mb-0">

            <li v-for="(tab, index) in tabs" :key="tab.page" :class="'page-item page-'+index">
                <a v-if="index == currentTab" class="page-link tab active border-0" :href="tab.page" :class="tab.className">{{ tab.pageName }}</a>
                <a v-else-if="tab.condition == true && onboardingSiteId === 0" class="page-link tab border-0" :class="tab.className" href="/onboarding/stranka?id=1&job=1">{{ tab.pageName }}</a>
                <!-- '/onboarding/stranka?timeline='+timelineStateId -->
                <a v-else-if="tab.condition == true && onboardingSiteId != 0" class="page-link tab border-0" :class="tab.className" :href="tab.page + onboardingSiteId + '&job=' + jobId" :title="$t('update_onboardingsite')+' '+$t('for_selected_job')">{{ tab.pageName }}</a>
                <a v-else class="page-link tab border-0" :class="tab.className" :href="tab.page">{{ tab.pageName }}</a>
            </li>

        </ul>
    </nav>
</template>

<script>
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
export default {
    name: "MainTabs",
    props: {
        tabs: {
            type: Array
        },
        currentTab: {
            type: Number,
            default: 1
        },
        filterValues: {
            type: Number
        },
        onboardingSiteId: {
            type: Number,
            default: 1
        },
        timelineStateId: {
            type: Number,
            default: 1
        },
        jobId: {
            type: Number,
            default: 1
        }
    },
    methods: {
        /**
         * Shake with selectbox if no job was selected
         * */
        shakeJobSelectbox(){

            if($('.filters-bar').hasClass('partially-hidden')){
                $('.btn-toggle-filters').trigger('click');
            }

            $('.single-filter #filter_with_job-onboarding').addClass('shake');
            this.$toastr.w(this.$t('before_continue_select_job'));
            setTimeout(function(){
                $('.single-filter #filter_with_job-onboarding').removeClass('shake');
                $('.single-filter #filter_with_job-onboarding').addClass('shake');

            }, 1600);
            setTimeout(function(){
                $('.single-filter #filter_with_job-onboarding').removeClass('shake');

            }, 3200);

        },

    }


}
</script>
